import { useDispatch, useSelector } from 'react-redux';
import { getRelatedSharing, getRelatedSharingInProgress } from '../selectors';
import { Button, message, Spin } from '@myua/kit';
import * as packActions from '../actions';

export const RelatedSharing = () => {
  const dispatch = useDispatch();
  const relatedSharing = useSelector(getRelatedSharing);
  const inProgress = useSelector(getRelatedSharingInProgress);

  if (!relatedSharing) {
    return null;
  }

  return (
    <div className="al-pack-related-sharing">
      <Spin spinning={inProgress}>
        <div className="al-pack-related-sharing__content">
          <div className="al-pack-related-sharing__text" title={relatedSharing.name}>
            <span className="al-pack-related-sharing__label">Editing:</span> {relatedSharing.name}
          </div>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              dispatch(packActions.saveRelatedSharingClicked());
            }}
          >
            Save
          </Button>
          <Button
            size="small"
            onClick={() => {
              dispatch(packActions.setRelatedSharing({ relatedSharing: undefined }));
              message.info('Editing cancelled');
            }}
          >
            Cancel
          </Button>
        </div>
      </Spin>
    </div>
  );
};
